export const CAMERA_STATES_MESSAGES = {
  WAITING: 'setup.camera.WAITING',
  ERROR: 'setup.camera.ERROR',
  READY: 'setup.camera.READY',
  SKIP: 'setup.camera.SKIP',
};

export const MICROPHONE_STATES_MESSAGES = {
  WAITING: 'setup.microphone.WAITING',
  ERROR: 'setup.microphone.ERROR',
  READY: 'setup.microphone.READY',
};

export const INTERNET_STATES_MESSAGES = {
  DISCONNECTED: 'setup.internet.NO_CONNECTED',
  TESTING: 'setup.internet.TESTING',
  SLOW_CONNECTION: 'setup.internet.SLOW',
  CONNECTED: 'setup.internet.CONNECTED',
};
